import { Languages, useLanguage, withLocale } from '@/contexts/LanguageContext';
import { Header } from '@/components/ui/Header';
import RentPriceStepper from '@/components/ui/RentPrice/Stepper';
import { GetServerSideProps } from 'next';
import { getLookup } from '../../utils/lookupHelpers';
import { useState } from 'react';

type RentPriceCalculatorProps = {};

export type RentPriceCalculatorStep = 'info' | 'input' | 'result';

const RentPriceCalculatorPage = (props: RentPriceCalculatorProps) => {
  const { t } = useLanguage();
  const [step, setStep] = useState<RentPriceCalculatorStep>('info');

  return (
    <>
      <Header
        showBackButton={step !== 'info'}
        overrideBackAction={() => {
          switch (step) {
            case 'info':
              return;
            case 'input':
              setStep('info');
              return;
            case 'result':
              setStep('input');
              return;
          }
        }}
        showLogoOnDesktop={step === 'info'}
      />
      <RentPriceStepper step={step} onStepChange={(step) => setStep(step)} />
    </>
  );
};

export default withLocale.hoc(RentPriceCalculatorPage);

export const getServerSideProps: GetServerSideProps<RentPriceCalculatorProps, { lang: Languages }> =
  withLocale.getServerSideProps<RentPriceCalculatorProps>(async (strapiLookup, lang) => {
    return {};
  }, getLookup);
